
<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import {getAxios} from "@/AxoisFactory"
@Options({
  components: {MainAppBar},
  data() {
    return {

    };
  },
  created() {
    console.log("mounted app")
    const axios = getAxios();
    axios.get("/gallery/categories").then((r: any) => {
      console.log(r);
      this.$store.commit("setPictureCategories", r.data);
    })
  },
  methods: {

  }
})
export default class App extends Vue {
}
</script>

<template>
    <router-view/>
</template>

<!-- Globális stílus és arculati tokenek: src/styles/app.css (main.ts-ben importálva) -->
